// Uwagi z analizy AI wypisów (proposal.notes): ⚠ = powód, dla którego czegoś brakuje
// (odmowa modelu, za duży plik, ucięta odpowiedź), ℹ = co zrobiliśmy z plikiem
// (odchudzenie, podział na części, przemapowane strony). Wspólne dla strony zamówienia
// i modalu recenzji, żeby oba źródła (zamówienie / wypis z działki) mówiły tak samo.
export function ExtractionNotes({ notes }: { notes?: string[] }) {
  if (!notes?.length) return null;
  return (
    <ul className="space-y-0.5 text-[11px]">
      {notes.map((note, i) => (
        <li
          key={i}
          className={
            note.startsWith("⚠")
              ? "text-amber-700 dark:text-amber-400"
              : "text-[var(--color-text-muted)]"
          }
        >
          {note}
        </li>
      ))}
    </ul>
  );
}

/** Ostatnia niepusta linia błędu zadania (traceback kończy się właściwym wyjątkiem;
 *  TaskFailure to jedna linia) — do pokazania obok „nie powiodła się”. */
export function taskErrorTail(error?: string | null): string {
  const lines = (error ?? "").trim().split("\n").map((l) => l.trim()).filter(Boolean);
  return (lines[lines.length - 1] ?? "").slice(0, 300);
}
